export default {
    Manual: 'Manual',
    QR: 'QR',
    IVR: 'IVR' // ?
}